module.exports = __webpack_public_path__ + "03_glasses_brown.69c6f7b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer4/03_glasses_brown.png
// module id = S+7c
// module chunks = 0